// Imports
import 'core-js';
import 'lazysizes';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes/plugins/respimg/ls.respimg';

// Modules
import './modules/externallinks';
import './modules/mobilemenu';
import './modules/subservicelist';
import './modules/informationslider';
import './modules/videoslider';
import './modules/historyplumbob';
import './modules/bodyscroll';
import './modules/swooshCollection';
import './modules/swoosh';
import './modules/videooverlay';
import './modules/imageSliderModal';
import './modules/cardsWithTextSlider';
import scrollTo from './modules/smoothscroll';
import './modules/designgear';
import { Accordion } from './modules/accordion';
import './modules/statCounter';
import './modules/homepageLineAnimation';
import './modules/homepageNavAnimation';

const links = document.querySelectorAll('.js-jumpNav');

if (links.length) {
  scrollTo(links);
}

document.addEventListener('DOMContentLoaded', (event) => {

  const accordionsArray = document.querySelectorAll('[data-accordion]');
  if (accordionsArray.length) {
    accordionsArray.forEach(accordion => {
      new Accordion(accordion);
    });
  }

  // Documentation for image comparison component
  // https://cloudfour.com/thinks/building-an-accessible-image-comparison-web-component/
  // https://image-compare-component.netlify.app/
  if(document.querySelector('image-compare')) {
    import('@cloudfour/image-compare');
  }

  // Handles converting CKEditor oembeds to iframes without external service
  // Find all oembed elements
  const oembedElements = document.querySelectorAll('[data-oembed-url]');

  // Function to extract the YouTube video ID from various URL formats
  function extractYouTubeId(url) {
    const regex = /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    const matches = url.match(regex);
    return matches ? matches[1] : null;
  }

  oembedElements.forEach(element => {
    const url = element.querySelector('iframe').getAttribute('src');
    let videoId = null;
    if (!url) return;
    videoId = extractYouTubeId(url);

    if (videoId) {
      // Create the iframe element for YouTube
      const iframe = document.createElement('iframe');
      iframe.setAttribute('src', `https://www.youtube.com/embed/${videoId}`);
      iframe.setAttribute('width', '560'); // Set width
      iframe.setAttribute('height', '315'); // Set height
      iframe.setAttribute('frameborder', '0');
      iframe.setAttribute(
        'allow',
        'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
      );
      iframe.setAttribute('allowfullscreen', 'true');
      iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
      iframe.title = 'YouTube video player';
      iframe.loading = 'lazy';
      iframe.style.aspectRatio = '16/9';
      iframe.style.width = '100%';
      iframe.style.display = 'block';
      iframe.style.height = 'auto';
      iframe.style.margin = '1.5rem auto';

      // Replace the oembed element with the iframe
      if (element.parentNode) {
        element.parentNode.replaceChild(iframe, element);
      }
    }
  });
});
